module.exports = model => {
  return (
    model instanceof Monaco.Model ||
    model instanceof Backbone.Model ||
    model instanceof Monaco.Collection ||
    model instanceof Backbone.Collection
  );
};
